/**
 * Module dependencies.
 */

import styled from '@emotion/styled';

/**
 * Export `ContainerWrapper` styled component.
 */

export const ContainerWrapper = styled.div<{
  relative?: boolean;
}>`
  max-width: 1600px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
`;
